module.exports = __webpack_public_path__ + "img/jifen.824d3c37.png";